/**
 * Consent-aware tracking loader.
 * Scripts are only injected when the user has accepted cookies.
 *
 * To activate tracking, replace the placeholder IDs below:
 *   GA_MEASUREMENT_ID  → your Google Analytics 4 ID (e.g. "G-XXXXXXXXXX")
 *   LINKEDIN_PARTNER_ID → your LinkedIn Insight Tag partner ID (e.g. "123456")
 *
 * Set to `null` to disable a tracker entirely.
 */

const GA_MEASUREMENT_ID: string | null = null; // TODO: Replace with your GA4 ID
const LINKEDIN_PARTNER_ID: string | null = null; // TODO: Replace with your LinkedIn partner ID

const CONSENT_KEY = "cookie-consent";

function hasConsent(): boolean {
  return localStorage.getItem(CONSENT_KEY) === "accepted";
}

let gaLoaded = false;
let liLoaded = false;

function loadGA() {
  if (gaLoaded || !GA_MEASUREMENT_ID) return;
  gaLoaded = true;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);
}

function loadLinkedIn() {
  if (liLoaded || !LINKEDIN_PARTNER_ID) return;
  liLoaded = true;

  (window as any)._linkedin_data_partner_ids = (window as any)._linkedin_data_partner_ids || [];
  (window as any)._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);

  const script = document.createElement("script");
  script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  script.async = true;
  document.head.appendChild(script);
}

/** Call after user accepts cookies or on page load if already accepted. */
export function initTracking() {
  if (!hasConsent()) return;
  loadGA();
  loadLinkedIn();
}

/** Remove tracking cookies and reload-safe state. */
export function revokeTracking() {
  // GA cookies
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (name.startsWith("_ga") || name.startsWith("_gid")) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
    }
  });
}
